'use client';

import { useAppSettings } from '@bells/core';
import { layoutSearchTitle } from '@bells/i18n';
import { Search } from 'lucide-react';

export const HeaderSearchMobileButton = () => {
  const { setUseSearch } = useAppSettings();

  return (
    <button
      onClick={() => setUseSearch(true)}
      className='inline-flex h-10 w-10 items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 xl:hidden [&>svg]:pointer-events-none [&>svg]:size-5 [&>svg]:shrink-0'
      data-sidebar='trigger'
    >
      <Search></Search>
      <span className='sr-only'>{layoutSearchTitle()}</span>
    </button>
  );
};
